<template>
  <div>
    <Hero
      title="Choose a template to get started!"
      subtitle="(we'll automatically fill it with your products and content 🚀)"
    >
      <p class="mt-2 hero-hint md:mt-6">How does it work&hellip;</p>

      <StepsLeft class="mx-auto" />

      <v-icon name="chevron-down" class="hero-icon" scale=".7" />
    </Hero>

    <Section class="p-4 md:p-6 lg:p-8">
      <Error
        v-if="!$apollo.loading && errors.length"
        message="It looks like we couldn't find any templates right now."
        :errors="errors"
        :error-action="onRetryClick"
        error-action-label="Retry?"
        class="max-w-md mx-auto mb-4 md:mb-8 lg:mb-12"
      />

      <div class="p-4 mb-6 bg-white rounded-lg md:p-6 md:mb-8">
        <Loader
          v-if="$apollo.loading && !errors.length"
          label="Loading Categories..."
        />

        <div v-if="!$apollo.loading && !errors.length">
          <TemplateSlider
            v-for="category in categories"
            :key="category.id"
            :category="category"
            class="template-slider"
          />
        </div>

        <!-- TODO: Add InfiniteLoader when Categories query supports pagination -->
      </div>

      <div class="mb-4 divider" />
    </Section>
  </div>
</template>

<script>
import { Categories } from "@/graphql/queries";
import TemplateSlider from "@/components/Templates/TemplateSlider";
import Error from "@/components/UI/Error";
import Loader from "@/components/UI/Loader";
import Hero from "@/components/UI/Hero";
import StepsLeft from "@/components/UI/StepsLeft";
import Section from "@/components/UI/Section";

export default {
  apollo: {
    $query: {
      fetchPolicy: "cache-first",
    },
    categories: {
      query: Categories,
      update: (data) => data.categories,
      error({ graphQLErrors }) {
        if (graphQLErrors.length) {
          // If we have an auth error return false here as the login modal should open...
          if (isAuthError(graphQLErrors)) return false;

          this.errors = graphQLErrors.map(({ message }) => message);
        }
      },
    },
  },
  name: "TemplateListing",
  components: {
    Error,
    Hero,
    Loader,
    Section,
    StepsLeft,
    TemplateSlider,
  },
  data() {
    return {
      categories: [],
      errors: [],
    };
  },
  mounted() {
    // Make sure the user is at the top of the screen as sometimes the browser remembers their last known scroll postion
    window.scrollTo(0, 0);
  },
  methods: {
    onRetryClick() {
      this.errors = [];
      this.$apollo.queries.categories.refetch();
    },
  },
};
</script>

<style scoped>
.hero-hint {
  @apply mb-2 text-grey-lightest;
  font-size: 12px;
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);

  @screen md {
    @apply mb-3;
  }
}

.hero-icon {
  @apply mt-4 text-white mb-0 opacity-75;
}
</style>
